export const environment = {
  name: 'staging',
  production: false,
  alias: 'Ambiente de Teste: Staging',
  behavior: {
    www: false,
    legacy: false,
  },
  timeout: {
    pix: 60,
  },
  waitingTime: {
    pix: 10,
    smsInSeconds: 60,
  },
  endpoint: {
    assets: 'https://stg.telepremiosdasorte.com.br',
    api: 'https://api-hml.telepremiosdasorte.com.br/v1',
    apiV2: 'https://api-hml.telepremiosdasorte.com.br/v2',
  },
  tm: {
    enabled: true,
    id: 'GTM-M437RJL3',
  },
  captcha: {
    enabled: false,
    siteKey: 'a1a1d0e4-548d-446b-82b1-466e71ac93db',
  },
  cookies: {
    domain: 'stg.telepremiosdasorte.com.br',
  },
  credentials: {
    publicKey: 'APP_USR-51b8646d-6a03-4cf3-a4c5-3ebae81e6407',
  },
};
